export class Authentication {
}
//# sourceMappingURL=Authentication.js.map